module.exports = __webpack_public_path__ + "img/book(9).7fae0201.png";